// extracted by mini-css-extract-plugin
export default {"wrapper":"wrapper--3ZPR6","icon":"icon--3oV96","button":"button--1XEuV"};